import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Alert } from '@mui/material';

// Cloud React components
import { Button, Input, Form, Select, ToggleSwitch, Slider } from '../../../../../../../components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import { Grid, Chip, Icon } from '@mui/material';
import { GeofenceRadiusValues, TypeLayer, TypeObjectMap } from 'Components/Map/providers/enums';
import IconPicker from 'Modules/.common/components/IconPicker';
import FromToMap from 'Components/Map/components/FromToMap';
import { useGeocoder } from 'Core/hooks';
import MapObject from 'Components/Map/providers/mapObject';
import { OrderData } from 'Core/data/Helpers';
import { radiusFeetToMeters, firstColorFlagTags, findColor, settingsDesignPolygon, validateLatLng, calcDistanceToPoints} from 'Components/Map/utils'
import Pill from "Components/Pill";
import TagsManage from 'Modules/.common/components/TagsManage';
import InputRadius from 'Components/Map/components/InputRadius';

//actions
import {
    clearRedux,
    mapGeofencesOpenEditCreateModal,
    mapGeofencesGetGeofence,
    getLandmarksAndGeofences as getKmls,
    setLatLng,
    pointersCreated,
    selectCreateClickMapType,
    addPointers,
    mapGeofencesEditCreateGeofence,
    addUpdateGeofence,
    mapGetGeofenceTagsToCreate,
    mapGetGeofenceTags
} from 'Redux/actions';

//style
import './style.scss';

/* const TypeGeofence = [
    { id: 1, maxPoints: 20, unitType: 'L2000C', type: TypeObjectMap.Polygon, name: messages['map_geofence_geofenceCreateEdit_max'] },
    { id: 2, maxPoints: 10, unitType: 'Webtech', type: TypeObjectMap.Polygon, name: messages['map_geofence_geofenceCreateEdit_polygon'] },
    { id: 3, maxPoints: 0, unitType: 'L2000E', type: TypeObjectMap.Circle, name: messages['map_geofence_geofenceCreateEdit_circle'] },
    { id : 4, maxPoints: 4, unitType: 'Xirgo', type: TypeObjectMap.Square, name: messages['map_geofence_geofenceCreateEdit_square'] } 
]; */

//define the area in metters to the circle and square objects
const maximunArea = 65535;

const GeofenceCreateEdit = (props) => {
    const dispatch = useDispatch();
    const { intl, mapRef } = props;
    const { messages } = intl;

    const containerContactsRef = useRef(null);
    const maxPoints = 20;

    const TypeGeo = [
        { id: 1, shape: 'polygon', type: TypeObjectMap.Polygon, name: messages['map_geofence_geofenceCreateEdit_polygon'] },
        { id: 2, shape: 'circle', type: TypeObjectMap.Circle, name: messages['map_geofence_geofenceCreateEdit_circle'] },
        { id: 3, shape: 'square', type: TypeObjectMap.Square, name: messages['map_geofence_geofenceCreateEdit_square'] },
    ];

    const TypeAlertOn = [
        { id: 1, value: 'In/Out', name: messages['map_geofence_geofenceCreateEdit_inout'] },
        { id: 2, value: 'In', name: messages['map_geofence_geofenceCreateEdit_in'] },
        { id: 3, value: 'Out', name: messages['map_geofence_geofenceCreateEdit_out'] }
    ];

    const defaultColor = '8677D9';

    const editCreateGeofence = useRef();
    const fromToMapRef = useRef();

    const {
        open,
        id,
        geofence,
        loadingGeofence,
        response,
        loadingResponse
    } = useSelector((state) => state.realtimeMapGeofenceCreateEditModuleRedux);

    const {
        pointersCreated: newPoint
    } = useSelector((state) => state.realtimeMapRedux);


    const { geofenceTagsToCreate: geofenceTags, geofenceTagsToCreateLoading: geofenceTagsLoading } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);

    const contacts = useSelector((state) => state.catalogsRedux.contacts);

    const [geofenceType, setGeofenceType] = useState(null);
    const [errorFormTime, setErrorFormTime] = useState('');
    const [showInsideDuration, setShowInsideDuration] = useState(false);
    const [formData, setFormData] = useState({ color: defaultColor, hoursEdit: 0, minsEdit: 0, isAlert: 0 });
    const [alerOnSelect, setAlertOnSelect] = useState();
    const [contactSelect, setContactSelect] = useState();
    const [nameErrorMessage, setNameErrorMessage] = useState("");
    const [tagErrorMessage, setTagErrorMessage] = useState("");
    const [onGetGeocoder, address, setAddress] = useGeocoder();
    const [group, setGroup] = useState();
    const [geofenceCreated, setGeofenceCreated] = useState(true);
    const [increaseHeight, setIncreaseHeight] = useState(false);
    const [restart, setRestart] = useState(0);

    const objectOnMap = 'mapObject_01';
    const geofenceToCreate = "geofenceCircle01";
    const defaulRadius = 15.24;

    useEffect(() => {
        mapRef?.current?.showLayer(TypeLayer.Units, false);
        dispatch(mapGetGeofenceTagsToCreate())

        //define default value for the colors 
        settingsDesignPolygon(mapRef, true, `#${defaultColor}`, `#${defaultColor}`);

        return () => {
            mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
            mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
            mapRef?.current?.showUnitsByPreferences();
            setGeofenceType(null);
            dispatch(clearRedux("MAP_GEOFENCE_EDIT_CREATE"));
        }
    }, []);

    useEffect(() => {
        if (id && open) {
            dispatch(mapGeofencesGetGeofence(id));
        }
    }, [id, open]);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                let messageToUser = response?.message || null
                if(response.message == 'Geofence duplicated name'){
                    messageToUser = messages['map_geofence_geofenceCreateEdit_error_message']
                }

                NotificationManager.error(
                    messageToUser || messages['errorMessage'],
                    messages['realtimemaps_geofences_create'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                dispatch(clearRedux("MAP_GEOFENCE_EDIT_CREATE", { response: null }));
            } else {
                NotificationManager.success(
                    messages['map_geofence_geofenceCreateEdit_success'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                const newResponse = { ...response, tagsId: response.tags ? response.tags.map((item) => item.id).join(',') : '' }
                dispatch(addUpdateGeofence(geofence ? "update" : "add", newResponse));
                dispatch(getKmls());
                dispatch(mapGetGeofenceTags())
                handleClose();
            }
        }
    }, [response, open]);

    useEffect(() => {
        if (geofence && open) {
            if (geofence.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['realtimemaps_geofences_create'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                setGeofenceType(TypeGeo.find((item) => item.shape == geofence?.shape));
                
                //set alert log
                setAlertOnSelect(TypeAlertOn.find((item) => item.value == geofence.alertOnType))
                //set contacts
                if (geofence?.contacts && geofence?.contacts?.length > 0) {
                    setContactSelect(geofence.contacts)
                }

                if (geofence?.insideDurationMins && geofence?.insideDurationMins > 0) {
                    setShowInsideDuration(true);
                }


                let hoursCalc = Math.floor(geofence?.insideDurationMins / 60);
                let minutesCalc = geofence?.insideDurationMins % 60;

                if (geofence?.tags)
                    setGroup(geofence?.tags.map((item) => ({ ...item, name: item.label, color: `#${item.color}` || `#${defaultColor}` })))

                //get lat_long
                let position = validateLatLng(geofence);
                
                if((position.lat == ''|| position.lng == '') && geofence.coordinates && geofence.coordinates[0] && geofence.coordinates[0]?.longitude){
                    //get coordinates
                    position = {
                        lat: geofence.coordinates[0].latitude || 0,
                        lng: geofence.coordinates[0].longitude || 0
                    };
                }

                let squareDistance = 0;
                //create object on map
                if(geofence?.shape === 'circle'){
                    mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                    onMapClickCircle({ lat: parseFloat(position?.lat), lng: parseFloat(position?.lng) }, geofenceToCreate, geofence.radius || defaulRadius);

                    let color = geofence?.color || defaultColor;
                    settingsDesignPolygon(mapRef, true, `#${color}`, `#${color}`);
                    mapRef.current.updateStyleToCreateObject()
                } else if(geofence?.shape === 'square'){
                    mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
                    onMapClickSquare({ lat: parseFloat(position?.lat), lng: parseFloat(position?.lng) }, geofenceToCreate, objectOnMap, geofence.radius);

                    let distanceInMetters = calcDistanceToPoints(
                        parseFloat(position.lat), parseFloat(position.lng),
                        parseFloat(position.lat), parseFloat(geofence.coordinates[1]?.longitude));

                    //calc square distance
                    squareDistance = Math.round(distanceInMetters);
                    //update object square

                    mapRef.current.setUpdateSquareDiagonally(squareDistance);
                    let color = geofence?.color || defaultColor;
                    settingsDesignPolygon(mapRef, true, `#${color}`, `#${color}`);
                    mapRef.current.updateStyleToCreateObject()
                }

                setFormData({
                    ...geofence,
                    color: geofence?.color || defaultColor,
                    hoursEdit: hoursCalc,
                    minsEdit: minutesCalc,
                    radius: geofence?.shape === 'square' ? squareDistance : geofence.radius,
                    tagsIds: geofence?.tags,
                    isAlert: geofence?.isAlert,
                    latitude: position?.lat ? parseFloat(position?.lat) : 0,
                    longitude: position?.lng ? parseFloat(position?.lng) : 0
                });
            }
        }
    }, [geofence, open]);

    useEffect(() => {
        if (address && address.result == true && open) {
            const { data } = address;
            if (data && data.length > 0) {
                dispatch(mapGeofencesEditCreateGeofence({
                    ...formData,
                    address: data[0].fulladdress,
                    city: data[0].city,
                    zip: data[0].postalcode,
                    state: data[0].state,
                    country: data[0].country
                }));
            }
        }else if(open && address){
            dispatch(mapGeofencesEditCreateGeofence({
                ...formData,
                address: "",
                city: "",
                zip: "",
                state: "",
                country: ""
            }));
        }
    }, [address, open]);

    const getDirection = useCallback((lat, lng) => {
        onGetGeocoder({
            from: 'latlng', //latlng, address
            lat: lat,
            lng: lng
        })
    });

    const onGetPoint = useCallback((position, idFromTo) => {

        if(geofenceType?.type === TypeObjectMap.Circle){
            mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
            if (position && position.length > 0) {
                onMapClickCircle({ lat: position[0]?.lat, lng: position[0]?.lng }, idFromTo, formData.radius || defaulRadius);
            }

        } else if(geofenceType?.type === TypeObjectMap.Square){
            mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
            if (position && position.length > 0) {
                onMapClickSquare({ lat: position[0]?.lat, lng: position[0]?.lng }, idFromTo, objectOnMap);
            }
        }

    });

    const onMapClickCircle = useCallback((latLng, idFromTo, radius) => {
        const position = { lat: latLng.lat, lng: latLng.lng };
        mapRef.current.addCircleOnMapToCreate(position, onUpdateList, idFromTo, objectOnMap, radius, maximunArea);
        dispatch(pointersCreated(true));
        
    });

    const onUpdateList = (distanceInMetters) => {
        setFormData(formData => ({ ...formData, radius: Math.round(distanceInMetters) }))
    }

    const onMapClickSquare = useCallback((latLng, idFromTo, radiusObject, radius = 0) => {
        
        //testing the object before the add the square
        const objectExist = mapRef.current.getObject(TypeObjectMap.Square, radiusObject) || null
        if (objectExist) return

        mapRef.current.addSquareOnMapToCreate(latLng, idFromTo, radiusObject, formData?.radius || radius || defaulRadius, formData?.freeRectangle, onUpdateList, maximunArea / 2);
        dispatch(pointersCreated(true));
    })

    const onChangeRadius = useCallback((radius) => {
        setFormData(formData => ({ ...formData, radius: radius }))
        if(geofenceType.type === TypeObjectMap.Circle){
            mapRef?.current?.updateCirclePoint(objectOnMap, null, radius, true);
        }else{
            //update the square object for Diagonally distance
            mapRef.current.setUpdateSquareDiagonally(radius);
        }
    });

    const onSubmit = useCallback(() => {
        if (!geofenceType) {
            return;
        }
        let isValid = true, oneMessage = false;

        if(!formData?.name || formData?.name?.length == 0){
            setNameErrorMessage(messages['required_field'])
            isValid = false;
        }

        if ((geofenceType.type === TypeObjectMap.Circle || geofenceType.type === TypeObjectMap.Square) && !newPoint && !geofence) {
            NotificationManager.warning(
                messages['map_geofence_geofenceCreateEdit_circleRequired'],
                messages['realtimemaps_geofences_create'],
                3000,
                null,
                null,
                'success',
            );
            isValid = false;
        }

        if (!group || (group && group.length == 0)) {
            setTagErrorMessage(messages["unit_settings_alert_tags_required"])
            isValid = false;
        }

        let latLng = {};
        let coordinates = [];
        if (geofence) {
            latLng = {
                latitude: geofence.latitude,
                longitude: geofence.longitude
            };
            coordinates = geofence.coordinates.map(coordinate => {
                return { latitude: coordinate.latitude, longitude: coordinate.longitude };
            });
        }

        let shape = "";
        if (geofenceType?.type === TypeObjectMap.Circle/*  && !geofence */) {
            let ccoordinates = mapRef?.current?.getCircleCoordinates();
            setGeofenceCreated(ccoordinates ? true : false)
            if(!ccoordinates) return 
            if (ccoordinates) {
                coordinates = ccoordinates;
                latLng = {
                    latitude: coordinates[0].latitude,
                    longitude: coordinates[0].longitude
                };
            }

            shape = "circle";
        } else if (geofenceType?.type === TypeObjectMap.Polygon && !geofence) {
            const { coordinates: pcoordinates, center } = mapRef.current.getPolygonCoordinates();
            setGeofenceCreated(pcoordinates ? true : false)
            if(!pcoordinates) return 
            if (pcoordinates && pcoordinates.length) {
                coordinates = pcoordinates;
                latLng = center;
            }
            shape = "polygon";
            if (coordinates.length <= 3) { //minimun points to polygon is 4
                NotificationManager.warning(
                    messages['map_geofence_geofenceCreateEdit_info_polygon'].replace('{maxPoints}', maxPoints),
                    messages['map_geofence_geofenceCreateEdit_create'],
                    3000,
                    null,
                    null,
                    'success',
                );
                isValid = false;
                oneMessage = true;
            }
        } else if (geofenceType?.type === TypeObjectMap.Square/*  && !geofence */) {
            const objectSquare = mapRef.current.getObject(TypeObjectMap.Square, objectOnMap);
            setGeofenceCreated(objectSquare ? true : false)
            //return the message to normal state after that 8 seconds
            setTimeout(() => { setGeofenceCreated(true)}, 8000)
            if(!objectSquare) return 
            coordinates = objectSquare.coordinates
            shape = "square";
            latLng = {
                latitude: objectSquare.position.lat,
                longitude: objectSquare.position.lng
            };
        }
        let minutes = (formData?.minsEdit == '') ? 0 : parseInt(formData?.minsEdit);
        let hours = (formData?.hoursEdit == '') ? 0 : parseInt(formData?.hoursEdit);
        let timeDuration = (!showInsideDuration) ? 0 : (hours * 60) + minutes;
        if (timeDuration > 7200) {
            setErrorFormTime(messages['map_geofence_error_time_duration'])
            isValid = false;
        }

        if (showInsideDuration && timeDuration == 0) {
            setErrorFormTime(messages['map_geofence_error_time_duration_min'])
            isValid = false;
        }

        
        

        //is update
        if (geofence?.id > 0) {

            if(!isValid) return;

            let updateGeofence = {
                id: geofence.id,
                name: formData?.name,
                tagsIds: group.map((item) => item.id),
                color: formData?.color,
                insideDurationMins: timeDuration,
                latitude: latLng.latitude,
                longitude: latLng.longitude,
                alertOnType: alerOnSelect.value,
                contacts: contactSelect ? contactSelect.map(item => item.id) : [],
                isAlert: formData?.isAlert,
                //add the chage values for radius
                radius: geofenceType?.type === TypeObjectMap.Circle ? Math.round(formData?.radius) || Math.round(defaulRadius) : 0,
                coordinates: coordinates
            };

            dispatch(mapGeofencesEditCreateGeofence(updateGeofence));
            dispatch(clearRedux("MAP_GEOFENCE_EDIT_CREATE", { loadingResponse: true }));
        } else {
            //create new geofence

            if ((!latLng?.latitude || !latLng.longitude) && !oneMessage) {
                NotificationManager.warning(
                    messages['realtimemaps_latLngError'],
                    messages['realtimemaps_geofences_create'],
                    3000,
                    null,
                    null,
                    'success',
                );
                isValid = false;
            }

            if(!isValid) return;

            setFormData({
                ...formData,
                tagsIds: group.map((item) => item.id),
                radius: geofenceType?.type === TypeObjectMap.Circle ? Math.round(formData?.radius) || Math.round(defaulRadius) : 0,
                color: formData?.color,
                insideDurationMins: timeDuration,
                latitude: latLng.latitude,
                longitude: latLng.longitude,
                alertOnType: alerOnSelect?.value || 'In/Out',
                contacts: contactSelect ? contactSelect.map(item => item.id) : [],
                shape: shape,
                coordinates: coordinates
            });
            getDirection(latLng.latitude, latLng.longitude); //save the geofence after find info for geocode
            dispatch(clearRedux("MAP_GEOFENCE_EDIT_CREATE", { loadingResponse: true }));
        }
    });

    const handleClose = useCallback((e) => {
        if (e) e.preventDefault();

        setAddress(null);
        setFormData({ color: defaultColor });
        setGeofenceType(null);
        setContactSelect(null);
        setAlertOnSelect(null);
        setErrorFormTime('');
        setShowInsideDuration(false);
        settingsDesignPolygon(mapRef, true, `#${defaultColor}`, `#${defaultColor}`); //set the default color to geofence
        dispatch(selectCreateClickMapType())
        dispatch(addPointers([]));
        dispatch(setLatLng(null));

        dispatch(mapGeofencesOpenEditCreateModal(false));
        dispatch(clearRedux("MAP_GEOFENCE_EDIT_CREATE"));
    });

    const pillItemClick = (item) => {
        setGeofenceType(item);
        dispatch(selectCreateClickMapType(item.type, maxPoints));
        dispatch(addPointers([]));
        setGroup(null);
        setAddress(null);
        dispatch(setLatLng(null));
        dispatch(pointersCreated(false));
        setFormData({ ...formData, radius: null });

        if (mapRef?.current?.clearInputSearchMap) {
            mapRef?.current?.clearInputSearchMap();
        }
    }

    //to select the option by user
    const onSelectTypeEvent = (event) => {
        setGeofenceCreated(true);
        if(event && event.id == "UNITS"){
            //increase space on form
            setIncreaseHeight(true)
        }else{
            setIncreaseHeight(false)
        }
    }
    const title = geofence ? `${messages['map_geofence_geofenceCreateEdit_editTitle']} '${geofence?.name}'` : `${messages['map_geofence_geofenceCreateEdit_createTitle']}`;

    return (
        <Modal
            title={title}
            open={open}
            loading={loadingGeofence || loadingResponse || geofenceTagsLoading}
            position="right"
            size="small"
            className="modal-top-0"
            headerStyle={{
                top: 0
            }}
            handleClose={handleClose}
        >
            <ModalBody>
                <div ref={containerContactsRef} style={{ padding: '18px 24px 24px 24px', height: '100vh' }}>
                    <Form ref={editCreateGeofence} onValidSubmit={onSubmit}>


                        {
                            !geofence &&
                            <div style={{ marginBottom: 12 }}>
                                <Grid>
                                    <label className="input-normal-label">{messages["map_geofence_geofenceCreateEdit_tags_shape"]}</label>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    spacing={1}
                                    style={{ marginBottom: 10 }}
                                >

                                    {
                                        TypeGeo.map((item) => {
                                            return (
                                                <Grid key={item.id} item xs>
                                                    <Pill
                                                        key={item.id}
                                                        textField={'name'}
                                                        item={item}
                                                        outlined={item.id !== geofenceType?.id}
                                                        onClick={(item) => {
                                                            pillItemClick(item);
                                                            setTimeout(()=> {
                                                                setRestart(restart + 1 )
                                                            }, 500);

                                                            //clear the error message
                                                            setTagErrorMessage("");
                                                            setNameErrorMessage("");
                                                            setGeofenceCreated(true);

                                                            //remove object on map
                                                            mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                                                            mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
                                                            
                                                        }}
                                                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                                                        label="pill-label-text"
                                                        colorField="default"
                                                        colorSelection={'66BB6A'}
                                                    />
                                                </Grid>
                                            )
                                        })
                                    }

                                </Grid>

                                {
                                    geofenceType
                                    &&
                                    <div style={{ marginTop: 12, marginBottom: 12 }}>
                                        <span>
                                            {
                                                geofenceType.id < 3
                                                    ?
                                                    messages['map_geofence_geofenceCreateEdit_info_polygon'].replace('{maxPoints}', maxPoints)
                                                    :
                                                    messages['realtimemaps_geofence_info_circle']
                                            }
                                        </span>
                                    </div>
                                }
                            </div>
                        }

                        {
                            geofenceType
                            &&
                            <React.Fragment>
                                <div style={{ width: '100%' }}>
                                    <Grid>
                                        <label className="input-normal-label">
                                            {messages["map_geofence_geofenceCreateEdit_tags_label"]}
                                            <span className="text-danger"> *</span>
                                        </label>
                                    </Grid>
                                    <Grid
                                        container
                                        wrap="nowrap"
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                    >
                                        <Grid item style={{ height: 0 }}>
                                            <div className="form-item">
                                                <IconPicker
                                                    color={formData?.color}
                                                    icon={null}
                                                    options={["color"]}
                                                    onChange={(color, icon) => {
                                                        setFormData({ ...formData, color: color, selectedColor: true })
                                                        //define default value for the colors 
                                                        settingsDesignPolygon(mapRef, true, `#${color}`, `#${color}`);
                                                        mapRef.current.updateStyleToCreateObject()
                                                    }}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid zeroMinWidth item xs>
                                            <Input
                                                id="name"
                                                //type={geofence ? "inline" : "text"}
                                                type={"text"}
                                                placeholder={messages['map_geofence_geofenceCreateEdit_name']}
                                                value={formData.name || ""}
                                                onChange={(value) => {                                                    
                                                    setFormData({ ...formData, name: value })
                                                    if(value?.length > 0){
                                                        setNameErrorMessage("")
                                                    }
                                                }}
                                                //required
                                                //requiredMessage={messages['required_field']}
                                                maxLength={50}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                {
                                    nameErrorMessage
                                    &&
                                    <Grid>
                                        <label className="labelError">
                                            {nameErrorMessage}
                                        </label>
                                    </Grid>
                                }
                                <div style={{ marginBottom: 6, marginTop: 20 }}>                                  
                                
                                    <TagsManage
                                        onlyTags={true}
                                        mode="selector"
                                        enableSelectAll={false}
                                        disableUntaggedSelection={true}
                                        height={120}
                                        label={messages["unit_settings_tags_simple"]}
                                        placeholder={messages["unit_settings_tags_search"]}
                                        required={true}
                                        value={group || []}
                                        onChange={(values) => {
                                            let newValues = [...values]
                                            //Add the number off the vehicles when user select a new element
                                            if (group && newValues && newValues.length > 0 && group.length < newValues.length) {
                                                newValues[newValues.length - 1] = {
                                                    ...newValues[newValues.length - 1],
                                                }
                                            }

                                            if (!formData?.selectedColor) {
                                                const colorFlag = firstColorFlagTags(newValues, formData?.color || defaultColor, formData?.selectedColor);
                                                setFormData({
                                                    ...formData,
                                                    color: colorFlag
                                                });
                                            }

                                            setGroup(newValues)
                                            setTagErrorMessage("")
                                            //setFormData({ ...formData, tags: newValues });
                                        }}
                                        menuStyle={{ maxHeight: '280px', maxWidth: '432px' }}
                                        isVisiblePill={true}
        
                                    />
                                </div>

                                {
                                    !geofence
                                    ?
                                    <div style={{ marginBottom: 10, paddingTop: 20 }}>
                                        <Grid>
                                            <label className="input-normal-label">{messages["unit_settings_tags_type"]}</label>
                                        </Grid>
                                        {
                                            (geofenceType?.type === TypeObjectMap.Circle || geofenceType?.type === TypeObjectMap.Square) ?
                                                <FromToMap
                                                    id={geofenceToCreate}
                                                    ref={fromToMapRef}
                                                    noMapClick
                                                    onGetAddress={(event) => {
                                                        onGetPoint(event, geofenceToCreate);
                                                    }}
                                                    onGetPosition={(position, id) => {
                                                        onGetPoint([position], id);
                                                    }}
                                                    onSelectSelectUnit={(unit) => {
                                                        onGetPoint([{
                                                            ...unit?.lastReading,
                                                            lat: unit?.lat,
                                                            lng: unit?.lng
                                                        }], geofenceToCreate);
                                                    }}
                                                    onClear={() => {
                                                        mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                                                        mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
                                                    }}
                                                    onSelectType={onSelectTypeEvent}
                                                    onClearMarker={() => {
                                                        mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                                                        mapRef.current.removeMapObject(geofenceToCreate, TypeObjectMap.Marker);
                                                    }}
                                                    messages={messages}
                                                    required={true}
                                                    restart={restart}
                                                    getCoordinates
                                                    pills
                                                    maxPoints={maxPoints}
                                                    entities={["ADDRESS", "MAP_CLICK", "UNITS", "LATLNG"]}
                                                /> :
                                                <FromToMap
                                                    id={"geofencePolygon01"}
                                                    ref={fromToMapRef}
                                                    onSelectSelectUnit={(unit) => {
                                                        mapRef?.current?.centerPointOnMap(unit?.lat, unit?.lng, 11);
                                                    }}
                                                    onSelectType={onSelectTypeEvent}
                                                    messages={messages}
                                                    createElements
                                                    required={false}
                                                    noMapClick
                                                    pills
                                                    isPolygon
                                                    restart={restart}
                                                    maxPoints={maxPoints}
                                                    entities={["ADDRESS", "MAP_CLICK", "UNITS"]}
                                                />
                                        }
                                        {
                                            !geofenceCreated
                                            &&
                                            <Grid>
                                                <label className="labelError">
                                                    {messages["map_geofence_geofenceCreateEdit_error_define_geofence"]}
                                                </label>
                                            </Grid>
                                        }
                                        
                                    </div>
                                    :
                                    <div style={{ paddingBottom: 20 }}>
                                        <div>
                                            <Input
                                                id="latlngInput"
                                                type="text"
                                                label={messages['mapLandmarkCreateEditLandmark_latLng']}
                                                placeholder={messages['mapLandmarkCreateEditLandmark_latLng']}
                                                value={`${parseFloat(formData.latitude || 0).toFixed(6)},${parseFloat(formData.longitude || 0).toFixed(6)}`}
                                                onChange={(value) => { }}
                                                //disabled
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                }

                                {
                                    ((geofenceType?.type === TypeObjectMap.Circle) || geofenceType?.type === TypeObjectMap.Square) &&
                                    <div>
                                        <Grid>
                                            <InputRadius 
                                                value={formData?.radius || defaulRadius}
                                                onChange={onChangeRadius}
                                                isSquare={(geofenceType?.type === TypeObjectMap.Square) || false}
                                            >
                                            </InputRadius>
                                        </Grid>
                                        
                                        {/* <Slider
                                            min={defaulRadius}
                                            max={geofenceType?.type === TypeObjectMap.Circle ? maximunArea : (maximunArea / 2)}
                                            sliderOneColor={false}
                                            showValue={false}
                                            valueLabelDisplay={'off'}
                                            value={formData.radius || defaulRadius}
                                            onChange={(event) => {
                                                onChangeRadius(event)
                                            }}
                                        /> */}
                                    </div>

                                }



                                <div style={{ paddingTop: 10 }}>
                                    <ToggleSwitch
                                        id={'haveAlertControl'}
                                        optionLabels={[messages['map_geofence_geofenceCreateEdit_alert'], messages['map_geofence_geofenceCreateEdit_alert']]}
                                        checked={Boolean(formData?.isAlert) || false}
                                        xxLarge
                                        mapToggle
                                        onChange={(checked) => {
                                            setFormData({
                                                ...formData,
                                                isAlert: checked ? 1 : 0,
                                                hoursEdit: !checked ? 0 : formData?.hoursEdit || 0,
                                                minsEdit: !checked ? 0 : formData?.minsEdit || 0
                                            })
                                            if (!checked) setShowInsideDuration(false)

                                            setTimeout(()=> {
                                                if (containerContactsRef.current) {
                                                    containerContactsRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
                                                    containerContactsRef.current.focus();
                                                }
                                            }, 500)
                                            
                                        }} />
                                </div>

                                {
                                    formData?.isAlert
                                    &&
                                    <React.Fragment>
                                        <div>
                                            <Select
                                                id="alertOn"
                                                value={alerOnSelect}
                                                onChange={(event) => setAlertOnSelect(event)}
                                                options={TypeAlertOn}
                                                textField="name"
                                                valueField="id"
                                                label={messages['map_geofence_geofenceCreateEdit_alerton']}
                                                placeholder={messages['map_geofence_geofenceCreateEdit_alerton']}
                                                required
                                                requiredMessage={messages['required_field']}
                                            />
                                        </div>

                                        <div className="insideDurationCreateEdit" >
                                            <label className="input-normal-label">{messages['map_geofence_geofenceCreateEdit_insideDuration']}</label>
                                        </div>
                                        <div className="insideDurationCreateEdit">
                                            <ToggleSwitch
                                                id={`showInsideDuration`}
                                                optionLabels={['ON', 'OFF']}
                                                checked={showInsideDuration}
                                                medium
                                                mapToggle
                                                onChange={(checked) => {
                                                    if (checked) {
                                                        setFormData({ ...formData, hoursEdit: 0, minsEdit: 0 })
                                                    }
                                                    setShowInsideDuration(checked)
                                                }} />
                                        </div>
                                        {
                                            showInsideDuration &&
                                            <div className="insideDurationCreateEdit">
                                                <Grid container  >
                                                    <Grid item sm={6}>
                                                        <div className="timeInsideContainer">
                                                            <Grid item sm={7} >
                                                                <input
                                                                    id="hoursEdit"
                                                                    type="text"
                                                                    value={formData?.hoursEdit}
                                                                    placeholder={0}
                                                                    onChange={(event) => {
                                                                        let int = event.target.value ? event.target.value?.replace(/[^\d]/, '') : '';
                                                                        setFormData({ ...formData, hoursEdit: int })
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item sm={5} style={{ textAlign: 'center' }}>
                                                                {messages['map_geofence_error_time_duration_hours']}

                                                            </Grid>
                                                        </div>
                                                    </Grid>
                                                    <Grid item sm={6}>
                                                        <div className="timeInsideContainer">
                                                            <Grid item sm={7} >
                                                                <input
                                                                    id="minsEdit"
                                                                    type="text"
                                                                    value={formData?.minsEdit}
                                                                    placeholder={0}
                                                                    onChange={(event) => {
                                                                        let int = event.target.value ? event.target.value?.replace(/[^\d]/, '') : '';
                                                                        if (int && int > 59) {
                                                                            int = 59;
                                                                        }
                                                                        setFormData({ ...formData, minsEdit: int })
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item sm={5} style={{ textAlign: 'center' }}>
                                                                {messages['map_geofence_error_time_duration_minutes']}
                                                            </Grid>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>

                                        }

                                        <div style={{ marginBottom: '300px' }}>
                                            <Select
                                                id="geofenceContacts"
                                                value={contactSelect}
                                                onChange={(event) => setContactSelect(event)}
                                                options={contacts || []}
                                                textField="title"
                                                valueField="id"
                                                label={messages['map_geofence_geofenceCreateEdit_contacts']}
                                                placeholder={messages['map_geofence_geofenceCreateEdit_contacts']}
                                                required
                                                requiredMessage={messages['required_field']}
                                                multiple
                                                selectedOptionsBelow
                                            />
                                        </div>
                                        <div id={'divToGeofenceContacts'}></div>
                                        
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                        {
                            increaseHeight
                            &&
                            <div id='increaseSpace' style={{ height: 200 }}></div>
                        }
                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ bottom: 50 }}>
                {
                    errorFormTime &&
                    <Alert severity="error">{errorFormTime}</Alert>
                }
                <Button
                    disabled={loadingGeofence || loadingResponse || geofenceTagsLoading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingGeofence || loadingResponse || geofenceTagsLoading}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        editCreateGeofence.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default injectIntl(GeofenceCreateEdit, { withRef: true });
